
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SelectTheClass extends Vue {
  @Prop({
    type: [String, Number],
    default: '',
  }) activeKey!: [string, number]

  @Prop({
    type: Array,
    default: () => [],
  }) tabs!: any[]

  private handleClick(key: string) {
    this.$emit('changeClassList', key);
  }
}

